import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <SEOHead
        title="Seite nicht gefunden | heilys.info"
        description="Die angeforderte Seite wurde nicht gefunden."
        canonical="https://heilys.info/"
        noIndex={true}
      />
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
          <p className="mb-6 text-xl text-muted-foreground">
            Seite nicht gefunden
          </p>
          <a
            href="/"
            className="inline-block rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Zurück zur Startseite
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
